import Link from "next/link";

export function WhatAreTheNamesLargeNumbers() {
  return (
    <>
      <p>
        Names of large numbers are terms used to represent numbers that are
        significantly larger than those commonly used in everyday language.
        Large numbers are typically categorized using a system of prefixes based
        on powers of 10. Here are some examples:
      </p>
      <ul>
        <li>
          <strong>
            Thousand (10<sup>3</sup>):
          </strong>{" "}
          1,000
        </li>
        <li>
          <strong>
            Million (10<sup>6</sup>):
          </strong>{" "}
          1,000,000
        </li>
        <li>
          <strong>
            Billion (10<sup>9</sup>):
          </strong>{" "}
          1,000,000,000
        </li>
        <li>
          <strong>
            Trillion (10<sup>12</sup>):
          </strong>{" "}
          1,000,000,000,000
        </li>
        <li>
          <strong>
            Quadrillion (10<sup>15</sup>):
          </strong>{" "}
          1,000,000,000,000,000
        </li>
        <li>
          <strong>
            Quintillion (10<sup>18</sup>):
          </strong>{" "}
          1,000,000,000,000,000,000
        </li>
        <li>
          <strong>
            Sextillion (10<sup>21</sup>):
          </strong>{" "}
          1,000,000,000,000,000,000,000
        </li>
        <li>
          <strong>
            Septillion (10<sup>24</sup>):
          </strong>{" "}
          1,000,000,000,000,000,000,000,000
        </li>
        <li>
          <strong>
            Octillion (10<sup>27</sup>):
          </strong>{" "}
          1,000,000,000,000,000,000,000,000,000
        </li>
        <li>
          <strong>
            Nonillion (10<sup>30</sup>):
          </strong>{" "}
          1,000,000,000,000,000,000,000,000,000,000
        </li>
      </ul>
      <p>
        References for
        <Link href={"https://en.wikipedia.org/wiki/Names_of_large_numbers"}>
          &nbsp; Names of large numbers
        </Link>
      </p>
    </>
  );
}
